<ng-container *transloco="let t">
  <h2 mat-dialog-title>
    {{ data?.title || t('GENERAL.ARE_YOU_SURE') }}
  </h2>

  <mat-dialog-content>
    @if (data?.bodyMessage; as msg) {
      <ng-container>
        {{ t(msg) }}
      </ng-container>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ data?.noButtonText || t('GENERAL.NO') }}
    </button>

    <span class="spacer"></span>

    <button mat-flat-button [mat-dialog-close]="true" color="primary">
      {{ data?.yesButtonText || t('GENERAL.YES') }}
    </button>
  </mat-dialog-actions>
</ng-container>
